import { Component, AfterViewInit, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from "ngx-spinner";
import { AlertboxComponent } from '../alertbox/alertbox.component'
import { MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { DatePipe } from '@angular/common';
import { log } from 'console';
import { element } from 'protractor';
import { HttpErrorResponse } from '@angular/common/http';
@Component({
  selector: 'app-subject-selection',
  templateUrl: './subject-selection.component.html',
  styleUrls: ['./subject-selection.component.scss']
})
export class SubjectSelectionComponent implements OnInit {
  subjectSelectionDetailsForm: FormGroup;
  dialogRef: MatDialogRef<any>;
  courseList: any;
  filteredCourseList: any;
  facultyList: any;
  filteredFacultyList: any;
  courseStreamList: any;
  examList: any;
  filteredExamList: any;
  filteredStreamList: any;
  stucourseClgMapList: any;
  filteredstucourseClgMapListList: any;
  disabled = false;
  disabledbutton = false
  showtxt = false;
  notOpen = false;
  AdmClosed = false;
  subList: any;
  filteredSubList: any;
  filteredstudyModeList: any;
  studyModeList: any;
  sTypeList: any;
  filteredsTypeList: any;
  CourseCode: any;
  savebtn: boolean;
  updateBtn: boolean;
  StrCode: any;
  InstId: any;
  Subs = false;
  OptSub = false;
  noCheckboxSelected = false;
  SubjectName: any[] = [];
  AllSub: any[] = [];
  Sub: any[] = [];
  optData: any;
  optDataForGroup: any;
  checkedValues: any;
  code: any;
  msg: any;
  SubjectData = [];
  parsedData: any;
  FromDate: Date;
  ToDate: Date;
  Course: any;
  College: any;
  RgId: any;
  emid: any;
  addmissionData: any;
  disableButton = true;
  msgShow = false
  StatusData: any;
  RgIdd: any;
  ExamSrNo: any;
  hasStatusU: any;
  hasStatusO: any;
  msgFail: boolean;
  Message2: string;
  CourseCodeee: string;
  ShIddddd: any;
  constructor(private fb: FormBuilder, public umsService: UmsService,
    private modalPopupService: ModalpopService, public datepipe: DatePipe,
    private spinner: NgxSpinnerService) { }
  StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
  submitButton = true;
  updateButton = false;
  BranchId = 0;
  admissionDetailsFormArray;
  selectedValues: any[] = [];
  newSelectedValues = [];
  Subjects: any[] = [];
  GroupData: any[] = [];
  selectedCheckboxes: any = [];
  selectedOptions: any = [];
  validationErrors: { [key: string]: string } = {};
  MinMax = false;
  session = sessionStorage.getItem('session');
  studentId = sessionStorage.getItem('StudentRGID');
  sessionList: any[];
  SessionFilterList: any[];
  Message
  ngOnInit(): void {
    console.log('course in session storage',sessionStorage.getItem("StuCoId"));
    
    this.Subs = false;
    this.OptSub = false;
    this.noCheckboxSelected = false;
    this.MinMax = false;
    this.notOpen = false;
    this.AdmClosed = false;
    this.validationErrors = {};
    this.StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
    this.session = sessionStorage.getItem('session');
    this.submitButton = true;
    this.updateButton = false;
    this.disabled = false;
    this.disabledbutton = false
    this.BranchId = 0;
    this.CourseCodeee =sessionStorage.getItem("StuCoId");
    this.subjectSelectionDetailsForm = this.fb.group({
      StuId: new FormControl(this.StudentPersonalId),
      SubSession: new FormControl(''),
      SubFacId: new FormControl(''),
      SubCoId: new FormControl(''),
      SubBrId: new FormControl(''),
      SubEmId: new FormControl(''),
      StuSubjectRg: new FormControl(''),
      SubCgId: new FormControl(''),
    });
    this.getSubjectSelectionData();
    this.getApplyData()
    this.getAdmissionDetails();
    this.getScretData();
    this.getSessionData()
    
    this.getValidate()
    this.getRgId();
  }

  getValidate() {
    let payload = {};
    payload['SnNo'] = sessionStorage.getItem('session');
    payload['InCode'] = 'SubSe'
    payload['CgCode'] = sessionStorage.getItem("StuCgId");
    payload['CoCode'] = sessionStorage.getItem("StuCoId");
    // payload['EmId'] = this.emid
    this.umsService.CheckValidDate(payload).subscribe(res => {
      if (res.status) {
        // this.subjectSelectionDetailsForm.controls['SubEmId'].setValue(res.data[0].EmId);

      }
      else {
        // this.subjectSelectionDetailsForm.controls['SubEmId'].setValue('');
      }
    });
  }
  onCheckbox(event: any, checkbox: any): void {
    this.noCheckboxSelected = false;
    if (typeof this.selectedCheckboxes[0] === "object") {
      this.selectedCheckboxes = []
    }
    if (typeof checkbox === "string") {
      const index = this.selectedCheckboxes.indexOf(checkbox);
      const isChecked = event.checked;

      if (isChecked && index === -1) {
        this.selectedCheckboxes.push(checkbox);
      } else if (!isChecked && index !== -1) {
        this.selectedCheckboxes.splice(index, 1);
      }
    }
    else if (typeof checkbox[0] === "object") {
      checkbox.forEach(element => {
        if (typeof element === "string") {
          const index = this.selectedCheckboxes.indexOf(element);
          const isChecked = event.checked;
          if (isChecked && index === -1) {
            this.selectedCheckboxes.push(element);
          } else if (!isChecked && index !== -1) {
            this.selectedCheckboxes.splice(index, 1);
          }
        }
      });
    }

  }

  checkMatchingOpCode(group: any) {
    return this.optData.some(item => item.OpCode === group.EsOpCode);
  }

  onCheckboxChanged(event: any, checkbox: any): void {
    let payload = {};
    payload['EcShId'] = this.ShIddddd;
    payload['EcInCode'] = 64;
    payload['EcOpId'] = 0;
    this.umsService.getSupExamEditRecord(payload).subscribe((res) => {
      if (res.status) {
        const statusO = res.data.find(item => item.EcStatus === "O")?.EcStatus;
        this.hasStatusU = res.data.some(item => item.EcStatus === 'U');
        this.hasStatusO = res.data.some(item => item.EcStatus === 'O');
        if (this.hasStatusO) {
          // Status 'O' present, so enable button and do not show message
          this.disableButton = false;
          // this.msgShow = false;
        } 
        else if (this.hasStatusU && this.StatusData == '') {
          this.disableButton = true;
          
        } else if (this.hasStatusU && this.StatusData != '') {
         this.disableButton = true;
          // this.msgShow = false;
        }
      } 
      else {
        this.disableButton = false;
      }
    });


    if (this.hasStatusO) {
      this.disableButton = false;
    } 
    else if (this.hasStatusU && this.StatusData == '') {
      // this.msgShow = true;
      this.disableButton = true;
      
    } else if (this.hasStatusU && this.StatusData != '') {
      
      this.disableButton = true;
    }
    this.noCheckboxSelected = false;
    const index = this.selectedCheckboxes.indexOf(checkbox);
    const isChecked = event.checked;
    if (isChecked && index === -1) {
      this.selectedCheckboxes.push(checkbox);
    } else if (!isChecked && index !== -1) {
      this.selectedCheckboxes.splice(index, 1);
    }
    this.validateCheckboxesForItem();
  }

  validateCheckboxesForItem(): void {
    if (this.hasStatusO) {
      this.disableButton = false;
    } 
    else if (this.hasStatusU && this.StatusData == '') {
      // this.msgShow = true;
      this.disableButton = true;
      
    } else if (this.hasStatusU && this.StatusData != '') {
       
      this.disableButton = true;
    }
    for (const item of this.optData) {
      const selectedForItem = this.selectedCheckboxes.filter(
        (checkbox) => checkbox.EsOpCode === item.OpCode
      );
      this.validateCheckboxes(item, selectedForItem);
    }
  }

  validateCheckboxes(item: any, selectedCheckboxes1: any[]): void {
    if (this.hasStatusO) {
      this.disableButton = false;
    } 
    else if (this.hasStatusU && this.StatusData == '') {
      // this.msgShow = true;
      this.disableButton = true;
      
    } else if (this.hasStatusU && this.StatusData != '') {
      
      this.disableButton = true;
    }
    const totalSelected = selectedCheckboxes1.length;
    const opMin = item.OpMin;
    const opMax = item.OpMax;
    const opCode = item.OpCode
    if (totalSelected < opMin || totalSelected > opMax) {
      this.validationErrors[item.OpCode] = `For OptionCode ${opCode} Select Minimum ${opMin} or Maximum ${opMax}`;
      this.disableButton = true;
    } else {
      delete this.validationErrors[item.OpCode];
      this.noCheckboxSelected = false;
      if (this.showtxt == false && this.notOpen == false && this.AdmClosed == false) {
        this.disableButton = false;
      }
      else {
        this.disableButton = true
      }

    }
    this.getValidationErrorsKeys()
  }

  getValidationErrorsKeys(): string[] {
    return Object.keys(this.validationErrors);
  }
  getScretData() {
    this.spinner.show()
    this.umsService.getSecretData().subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        this.InstId = res.projectPharam['ClubPartTrans'];
      }
      else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  onSelectionChange(event: any) {
    // this.selectedValues = event.value;
    this.newSelectedValues = event.value
  }

  getScrutiny() {
    this.spinner.show();
    const payload = {};
    payload['StudentId'] = sessionStorage.getItem('StudentPersonalId');
    this.umsService.fetchScrutinyLock(payload).subscribe(res => {
      if (res.data.length == 0 || res.data[0]['Status'] == 'DCERR') {
        this.spinner.hide()
        this.disabledbutton = false
      }
      else {
        this.spinner.hide()
        this.disabledbutton = true;
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  shouldCheckItemForGroup(child): boolean {
    if (this.hasStatusO) {
      this.disableButton = false;
    } 
    else if (this.hasStatusU && this.StatusData == '') {
      // this.msgShow = true;
      this.disableButton = true;
      
    } else if (this.hasStatusU && this.StatusData != '') {
        this.disableButton = true;
    }
    return this.selectedCheckboxes.some(item => item.EsId === child.EsId);

  }

  shouldCheckItemForSubject(item1): boolean {
    return this.selectedCheckboxes.some(item => item.EsId === item1.EsId);
    // return this.newSelectedValues.some(item => item === item1.EsParent)
  }



  NewCoSch(CoCode, CShSnNo, StuId, StuCgId) {
    this.spinner.show();
    const payload = {};
    payload['CoCode'] = CoCode;
    payload['CShStatus'] = '';
    payload['LoginId'] = 0;
    payload['CShSnNo'] = CShSnNo;
    this.umsService.NewCoSch(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.NewSearchCoSch(res.data[0]['CShId'], CoCode, CShSnNo, StuId, StuCgId)
      }
      else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  NewSearchCoSch(ShId, CoCode, CShSnNo, StuId, StuCgId) {
    this.spinner.show();
    const payload = {};
    payload['CEcShId'] = ShId;
    this.umsService.NewSearchCoSch(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.personalDetails(res.data[0]['CEcId'], CoCode, CShSnNo, StuId, StuCgId)
      }
      else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }
  personalDetails(ECID, CoCode, CShSnNo, StuId, StuCgId) {
    this.spinner.show();
    let payload = {};
    payload['StuRgNo'] = this.studentId
    this.umsService.fetchPersonalDetails(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        let data = res.data[0]
        this.RegnForm(ECID, CoCode, CShSnNo, StuId, StuCgId, data.StuFirstNameEng, data.StuRgNo, data.StuMidNameEng, data.StuBirthDate, data.EmailID)
      }
      else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }

  RegnForm(EcId, CoCode, CShSnNo, StuId, StuCgId, Name, RgNo, Father, BirthDate, EMail) {
    this.spinner.show();
    const payload = {};
    payload['CSExBr'] = '';
    payload['Code'] = '';
    payload['Colg'] = '';
    payload['valid'] = 'Y';
    payload['changed'] = '';
    payload['CgCodee'] = '';
    payload['Batch'] = '';
    payload['Name'] = Name;
    payload['RgNo'] = RgNo;
    payload['FormNo'] = '';
    payload['CgCode'] = StuCgId;
    payload['Chng'] = 'Y';
    payload['Valid'] = '';
    payload['Father'] = Father;
    payload['Mother'] = '';
    payload['BirthDate'] = BirthDate;
    payload['Sex'] = 'M';
    payload['Cate'] = 'R';
    payload['Caste'] = 'OBC';
    payload['EMail'] = EMail;
    payload['Medium'] = 'E';
    payload['Nation'] = '1';
    payload['Mobile'] = '';
    payload['Addr1'] = '';
    payload['Addr2'] = '';
    payload['Addr3'] = '';
    payload['Addr1P'] = '';
    payload['Addr2P'] = '';
    payload['Addr3P'] = '';
    payload['Pin'] = '';
    payload['PinP'] = '';
    payload['Place'] = '';
    payload['StrCode'] = this.StrCode ? this.StrCode : 0;
    payload['PlaceP'] = '';
    payload['ExSub'] = '';
    payload['Sub'] = '';
    payload['EcId'] = EcId;
    payload['CoCode'] = CoCode;
    payload['SnNo'] = CShSnNo;
    payload['EmSrNoF'] = '';
    payload['msg'] = '';
    payload['EmSkip'] = '';
    payload['StuId'] = StuId;
    this.umsService.RegnTemp(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.Validate(EcId, RgNo, CShSnNo, StuCgId, CoCode);

      } else {
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  Validate(EcId, RgNo, CShSnNo, CgCode, CoCode) {
    this.spinner.show();
    const payload = {};
    payload['Batch'] = '';
    payload['EcId'] = EcId;
    payload['Inst'] = this.InstId;
    this.umsService.ValidateTemp(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        this.checkTemp(RgNo, CShSnNo, CgCode, CoCode);
      }
      else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  checkTemp(RgNo, CShSnNo, CgCode, CoCode) {
    this.spinner.show();
    const payload = {};
    payload['RgNo'] = RgNo;
    payload['SnNo'] = CShSnNo;
    payload['CgCode'] = CgCode;
    payload['CoCode'] = CoCode;
    this.umsService.checkTemp(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.data[0]['Mesg'] != '') {
        this.spinner.hide();
        let data = {};
        data['message'] = res.data[0]['Mesg'];
        data['title'] = 'Information';
        data['icon'] = 'fas fa-check';
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(
          AlertboxComponent,
          data
        );

      }
      else if (res.data[0]['Mesg'] == '') {
        this.spinner.hide();
        // this.next.emit();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });

  }

  UpdateDetails() {
    for (let i = this.selectedCheckboxes.length - 1; i >= 0; i--) {
      if (this.selectedCheckboxes[i].EsType === 'P') {
        this.selectedCheckboxes.splice(i, 1);
      }
    }
    if (this.selectedCheckboxes.length == 0) {
      this.noCheckboxSelected = true
      return
    }
    else {
      this.disableButton = false;
      if (typeof this.selectedCheckboxes[0] === "string") {
        this.update()
      } else if (typeof this.selectedCheckboxes[0] == "object") {
        this.validateCheckboxesForItem();
        const isEmpty = Object.keys(this.validationErrors).length === 0;

        if (!isEmpty) {
          this.disableButton = true;

        } else if (isEmpty) {
          this.disableButton = false;
          this.update();

        }

      }

    }

  }

  update() {
    if (this.subjectSelectionDetailsForm.invalid) {

    } else {
      let SubSecId = sessionStorage.getItem('SubSecId');
      this.submitButton = false;
      this.updateButton = true;
      this.spinner.show();
      let payload = this.subjectSelectionDetailsForm.value;
      payload.StuId = parseInt(payload.StuId);
      payload.SubEmId = String(payload.SubEmId);
      payload.SubSession = String(payload.SubSession);
      if (this.selectedCheckboxes.length == 0) {
        payload.StuSubjectRg = [''];
      }

      // payload.SessionId = this.session;
      if (typeof this.selectedCheckboxes[0] === "string") {
        const result = [this.selectedCheckboxes.join(',')];
        payload.StuSubjectRg = result;
      } else if (typeof this.selectedCheckboxes[0] == "object") {
        let selectedSubjects = [...this.selectedCheckboxes];
        for (let i = selectedSubjects.length - 1; i >= 0; i--) {
          if (selectedSubjects[i].EsType === 'G') {
            selectedSubjects.splice(i, 1);
          }
        }
        let esCodeArray = selectedSubjects.map(item => item.EsCode);
        const result = [esCodeArray.join(',')];
        payload.StuSubjectRg = result;
      }
      let combinedValues = [];
      this.selectedCheckboxes.forEach(item => {
        if (item.EsType === 'G') {
          combinedValues.push(`${item.EsCode}-${item.EsId}`);
        } else if (item.EsType === 'S') {
          combinedValues.push(`${item.EsCode}-${item.EsParent}`);
        }
      });

      const result2 = [combinedValues.join(',')];
      payload['SubSecId'] = parseInt(SubSecId);
      payload['StuSubjectRgCopy'] = result2
      this.umsService.updateSubjectSelectionDetails(payload).subscribe(res => {
        this.spinner.hide();
        if (res.status) {
          if (this.InstId == 17) {
            this.updateReAddmission(payload)
          }
          let data = {}
          data['message'] = res.message
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
          this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
          // this.next.emit();
          this.dialogRef.afterClosed().subscribe((result) => {
            // this.ngOnInit()
            this.getSubjectSelectionData();
            location.reload();
          });
        }
        else {
          this.spinner.hide();
          let data = {}
          data['message'] = res.message
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
          this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
          // this.next.emit();
          this.dialogRef.afterClosed().subscribe((result) => {
            // this.NewCoSch(payload.StuCoId, payload.SessionId, payload.StuId, payload.StuCgId);
          });
        }

      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
      }
      );
    }
  }

  getFacultyData(FcCode) {
    this.spinner.show();
    const payload = {};
    this.Subjects = [];
    this.GroupData = [];
    payload['FcCode'] = FcCode
    this.umsService.fetchFaculty(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.Subjects = [];
        this.GroupData = [];
        this.facultyList = res.data;
        this.filteredFacultyList = this.facultyList.slice();
        this.subjectSelectionDetailsForm.controls['SubFacId'].setValue(res.data[0].FcCode);
      }
      else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  getCourseData(id) {
    this.spinner.show()
    const payload = {};
    //"CoFcCode": "MBBS"
    payload['CoFcCode'] = id;
    //payload['EmId'] = 0;
    // this.admissionDetailsForm.controls['StuCoId'].setValue('')
    this.filteredCourseList = [];
    this.filteredStreamList = [];
    this.StrCode = '';
    this.filteredExamList = [];
    this.filteredSubList = [];
    this.selectedValues = [];
    //this.newSelectedValues = [];
    this.Subjects = [];
    this.GroupData = [];
    this.SubjectName = [];
    this.AllSub = [];
    this.Sub = [];
    this.filteredstucourseClgMapListList = [];
    this.umsService.fetchCourseType(payload).subscribe(res => {
      if (res.status) {
        this.Subjects = [];
        this.GroupData = [];
        this.spinner.hide()
        this.courseList = res.data;
        this.filteredCourseList = this.courseList.slice();
      }
      else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  getExamStreamData(id) {
    this.spinner.show()
    this.filteredStreamList = [];
    this.StrCode = '';
    this.BranchId = 0;
    this.filteredExamList = [];
    this.filteredSubList = [];
    this.selectedValues = [];
    //this.newSelectedValues = [];
    this.Subjects = [];
    this.GroupData = []
    this.SubjectName = [];
    this.AllSub = [];
    this.Sub = [];
    this.filteredstucourseClgMapListList = [];
    this.CourseCode = id;
    sessionStorage.setItem("CoCodeee", this.CourseCode)
    const payload = {};
    payload['CoCode'] = id;
    payload['EmId'] = 0;
    this.umsService.fetchCourseBranch(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide()
        this.courseStreamList = res.data;
        this.filteredStreamList = this.courseStreamList.slice();
        this.subjectSelectionDetailsForm.controls['SubBrId'].setValue(res.data[0].StrId);
      }
      else {
        this.spinner.hide()
        this.BranchId = 0;
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    }
    );

    const payload2 = {};
    payload2['EmCoCode'] = id;
    payload2['EmId'] = 0;
    this.Subjects = [];
    this.GroupData = []
    this.umsService.fetchExam(payload2).subscribe(res => {
      if (res.status) {
        this.spinner.hide()
        this.Subjects = [];
        this.GroupData = []
        this.examList = res.data;
        this.filteredExamList = this.examList.slice();
      }
      else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
    const payload3 = {};
    payload3['CoCode'] = id;
    this.filteredstucourseClgMapListList = [];
    this.umsService.fetchstucourseClgMap(payload3).subscribe(res => {
      if (res.status) {
        this.spinner.hide()
        this.stucourseClgMapList = res.data;
        this.filteredstucourseClgMapListList = this.stucourseClgMapList.slice();
      }
      else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  getExam(id) {
    this.spinner.show();
    this.Subjects = [];
    this.GroupData = []
    this.optData = '';
    const payload2 = {};
    payload2['EmCoCode'] = id;
    payload2['EmId'] = 0;
    this.umsService.fetchExam(payload2).subscribe(res => {
      if (res.status) {
        this.spinner.hide()
        this.Subjects = [];
        this.GroupData = []
        this.examList = res.data;
        this.filteredExamList = this.examList.slice();
      }
      else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });

  }

  getSubData(id) {
    this.spinner.show()
    let data = this.subjectSelectionDetailsForm.value
    const payload = {};
    payload['EsEmId'] = id.EmId;
    payload['EsStrId'] = this.BranchId;
    this.umsService.fetchSubs(payload).subscribe(async res => {
      if (res.status) {
        this.spinner.hide()
        this.Subjects = [];
        this.GroupData = []
        this.selectedCheckboxes = [];
        this.SubjectName = [];
        this.AllSub = [];
        this.Sub = []
        await this.getExamSubMapFetch(this.subjectSelectionDetailsForm.value['SubEmId'], this.BranchId);
        this.subList = res.data;
        this.filteredSubList = this.subList.slice();
      }
      else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  getExamSubMapFetch(EmId, BranchId) {
    this.Subjects = [];
    this.GroupData = [];
    this.Subs = false;
    this.OptSub = false;
    this.spinner.show();
    const payload = {};
    payload['EsEmId'] = EmId;
    payload['EsStrId'] = BranchId;
    this.umsService.getExamSubMapFetch(payload).subscribe(async res => {
      if (res.status) {
        this.spinner.hide();
        this.SubjectData = res.data.children;
        this.SubjectData.forEach(element => {
          if (element.EsType == 'S') {

            this.Subs = true;
            if (this.Subjects.indexOf(element.EsCode) === -1) {
              this.Subjects.push(element.EsCode);
              this.SubjectName.push(element.EsName);
              this.Sub.push(element.EsOpCode)
              this.AllSub.push(element)
              if (element.EsOpCode !== ' ') {
                const DupOpt = this.selectedOptions.some((item: any) => item === element.EsOpCode);
                if (!DupOpt) {
                  this.selectedOptions.push(element.EsOpCode);
                }
              }
            }
            if (element.EsOpCode == " " && element.EsType == 'S') {
              const isDuplicate = this.selectedCheckboxes.some((item: any) => item.EsId === element.EsId);
              if (!isDuplicate) {
                this.selectedCheckboxes.push(element);
              }
            }
            this.newSelectedValues.forEach(element2 => {
              if (element2.Code == element.EsCode && element2.Id == element.EsParent) {
                const isDuplicate = this.selectedCheckboxes.some((item: any) => item.EsId === element.EsId);
                if (!isDuplicate) {
                  this.selectedCheckboxes.push(element);
                }

              }
            })
          }
          else if (element.EsType == 'G') {
            this.OptSub = true;
            if (element.EsOpCode !== ' ') {

              const DupOpt = this.selectedOptions.some((item: any) => item === element.EsOpCode);
              if (!DupOpt) {
                this.selectedOptions.push(element.EsOpCode);
              }
            }
            const isDuplicate = this.GroupData.some((item: any) => item.EsId === element.EsId);
            if (!isDuplicate) {
              this.GroupData.push(element);
            }
            element.children.forEach(element1 => {
              if (element1.EsOpCode !== ' ') {
                const DupOpt = this.selectedOptions.some((item: any) => item === element1.EsOpCode);
                if (!DupOpt) {
                  this.selectedOptions.push(element1.EsOpCode);
                }
              }

              if (element1.EsOpCode == " ") {
                const isDuplicate = this.selectedCheckboxes.some((item: any) => item.EsId === element1.EsId);
                if (!isDuplicate) {
                  this.selectedCheckboxes.push(element1);
                }
              }

              this.newSelectedValues.forEach(element2 => {

                if (element2.Code == element1.EsCode && element2.Id == element1.EsParent) {
                  const isDuplicate = this.selectedCheckboxes.some((item: any) => item.EsId === element1.EsId);
                  if (!isDuplicate) {
                    this.selectedCheckboxes.push(element1);
                  }

                }

              })
            });

            this.newSelectedValues.forEach(element2 => {

              if (element2.Code == element.EsCode && element2.Id == element.EsId) {
                const isDuplicate = this.selectedCheckboxes.some((item: any) => item.EsId === element.EsId);
                if (!isDuplicate) {
                  this.selectedCheckboxes.push(element);
                }

              }

            })
            for (const value of this.newSelectedValues) {
              element.children.forEach(element2 => {
                if (element2.EsOpCode !== ' ') {
                  const DupOpt = this.selectedOptions.some((item: any) => item === element2.EsOpCode);
                  if (!DupOpt) {
                    this.selectedOptions.push(element2.EsOpCode);
                  }
                }
              });
            }

          } else {
          }
        });
        await this.getOptionData(EmId, BranchId);
      }
      else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });


  }

  getOptDataForGroup(group: any) {
    return this.optData.find(item => item.OpCode === group.EsOpCode);
  }

  minmaxsubject(q) {
    q.forEach(element => {
      if (element.EsOpCode != ' ') {
        let EsOpCode = element.EsOpCode
        this.optData.forEach(element1 => {
          if (element1.OpCode === EsOpCode) {
            let OptionData = element1
            this.code = OptionData.OpCode
            this.msg = `Minimum = ` + OptionData.OpMin + ` & Maximum = ` + OptionData.OpMax
          }
        });
      }
    });
    return this.msg
  }

  getOptionData(EmId, BranchId) {
    this.optData = '';
    this.spinner.show();
    const payload = {};
    payload['OpEmId'] = EmId;
    payload['OpStrId'] = BranchId;
    this.umsService.getOption(payload).subscribe((res) => {
      if (res.status == true) {
        this.spinner.hide();
        const filteredArray = res.data.filter(item => this.selectedOptions.includes(item.OpCode));
        // this.optData = res.data.find(item => item.OpCode === group.EsOpCode);
        this.optData = filteredArray;
        this.MinMax = true;
      }
      else {
        this.spinner.hide();
        this.MinMax = false;
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  getBrId(id, code) {
    this.BranchId = id;
    this.StrCode = code;
  }

  getData(e) {
  }

  submitDetails() {
    if (this.subjectSelectionDetailsForm.invalid) {
      // this.admissionDetailsForm.get('StuStyMode').markAsTouched();
      // this.admissionDetailsForm.get('StuCoLvl').markAsTouched();
      // this.admissionDetailsForm.get('StuType').markAsTouched();
      // this.admissionDetailsForm.get('StuFacId').markAsTouched();
      // this.admissionDetailsForm.get('StuCoId').markAsTouched();
      // this.admissionDetailsForm.get('StuBrId').markAsTouched();
      // this.admissionDetailsForm.get('StuEmId').markAsTouched();
      // this.admissionDetailsForm.get('StuCgId').markAsTouched();
      // this.admissionDetailsForm.get('StuExamCenter').markAsTouched();
    } else {
      this.submit()
    }

  }

  submit() {
    for (let i = this.selectedCheckboxes.length - 1; i >= 0; i--) {
      if (this.selectedCheckboxes[i].EsType === 'P') {
        this.selectedCheckboxes.splice(i, 1);
      }
    }

    if (this.selectedCheckboxes.length == 0) {
      this.validateCheckboxesForItem();
      this.noCheckboxSelected = true
      return
    }

    else {

      this.disableButton = false;
      if (typeof this.selectedCheckboxes[0] === "string") {
        this.submitFinal()
      } else if (typeof this.selectedCheckboxes[0] == "object") {
        this.validateCheckboxesForItem();
        const isEmpty = Object.keys(this.validationErrors).length === 0;

        if (!isEmpty) {
          this.disableButton = true;
          // this.submit();

        } else if (isEmpty) {
          this.disableButton = false;
          this.submitFinal();

        }

      }
    }
  }

  submitFinal() {
    let combinedValues = [];
    this.submitButton = true;
    this.updateButton = false;
    this.spinner.show();
    let payload = this.subjectSelectionDetailsForm.value;
    payload.StuId = parseInt(sessionStorage.getItem('StudentPersonalId'));
    payload.SubEmId = payload.SubEmId;
    payload.SubSession = parseInt(this.session);
    if (typeof this.selectedCheckboxes[0] === "string") {
      const result = [this.selectedCheckboxes.join(',')];
      payload.StuSubjectRg = result;
    } else if (typeof this.selectedCheckboxes[0] == "object") {
      let selectedSubjects = [...this.selectedCheckboxes];
      for (let i = selectedSubjects.length - 1; i >= 0; i--) {
        if (selectedSubjects[i].EsType === 'G') {
          selectedSubjects.splice(i, 1);
        }
      }
      let esCodeArray = selectedSubjects.map(item => item.EsCode);
      const result = [esCodeArray.join(',')];
      payload.StuSubjectRg = result;
    }
    this.selectedCheckboxes.forEach(item => {
      if (item.EsType === 'G') {
        // For EsType G, storing EsCode-EsId
        combinedValues.push(`${item.EsCode}-${item.EsId}`);
      } else if (item.EsType === 'S') {
        // For EsType S, storing EsCode-EsParent
        combinedValues.push(`${item.EsCode}-${item.EsParent}`);
      }
    });

    const result2 = [combinedValues.join(',')];
    payload['StuSubjectRgCopy'] = result2
    this.spinner.hide();
    // this.Validate('x');
    // this.NewCoSch(payload.StuCoId,payload.SessionId,payload.StuId,payload.StuCgId);
    //let payload = {};
    this.umsService.addSubjectSelectionDetails(payload).subscribe(res => {
      if (this.InstId == 17) {
        this.ReAddmission(payload);
      }
      this.spinner.hide();
      let data = {}
      data['message'] = res.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      this.dialogRef.afterClosed().subscribe((result) => {
        this.ngOnInit()
      });
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      // this.ngOnInit();
      this.dialogRef.afterClosed().subscribe((result) => {
        // this.NewCoSch(payload.StuCoId, payload.SessionId, payload.StuId, payload.StuCgId);
      });
    }
    );
  }
  back() {
    // this.prev.emit();
  }

  scrutenylevelCheck(item) {
    this.spinner.show();
    let colgCode = item.CgCode;
    let code = sessionStorage.getItem("CoCodeee")
    const payload = {};
    payload['CoCode'] = code;
    payload['CgCode'] = colgCode;
    payload['SessionId'] = this.session;

    this.umsService.getAssignLevel(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.data.length < 1) {
        // this.savebtn = false;
        // this.updateBtn = false;
        let data = {}
        data['message'] = "For the selected college and course admissions are not open"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          // this.submitButton = false;
          // this.updateButton = false;
          this.disabled = false;
          this.showtxt = false;
        });
      } else {
        //this.apimicroservice.openSnackbar(res.message);
        // this.savebtn = true;
        // this.updateBtn = true;
        this.disabled = false;
        this.showtxt = false;
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  cutoff(code) {
    this.spinner.show()
    this.notOpen = false;
    this.AdmClosed = false;
    this.showtxt = false;
    this.disabled = false;
    let data = this.subjectSelectionDetailsForm.value
    const payload = {};
    payload['SessionID'] = parseInt(sessionStorage.getItem('session'));
    payload['CoCgCgCode'] = code;
    payload['CoCgCoCode'] = data.StuCoId;
    payload['InCode'] = "ADM";
    payload['EmId'] = '';
    this.umsService.findSessionCutOff(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide()
        this.showtxt = false;
        const todayDate = new Date();

        for (const element of res.data) {
          const fromdate = new Date(element['CutOffDateFrom']);
          const toDate = new Date(element['CutOffDate']);

          // Set hours, minutes, seconds, and milliseconds to 0 for accurate date comparison
          todayDate.setHours(0, 0, 0, 0);
          fromdate.setHours(0, 0, 0, 0);
          toDate.setHours(0, 0, 0, 0);
          if (todayDate >= fromdate && todayDate <= toDate) {
            this.notOpen = false;
            this.disabled = false
            this.AdmClosed = false;
            break; // Exit the loop if the registration is open
          } else if (todayDate < fromdate) {
            this.FromDate = fromdate;
            this.notOpen = true;
            this.disabled = true;
            this.AdmClosed = false;
            break; // Exit the loop if registration is not open yet
          }
        }

        // If none of the conditions were met, it means today's date is after all the cutoff dates
        if (this.AdmClosed === undefined) {
          this.AdmClosed = true;
          this.disabled = true
        }
      }
      else {
        this.spinner.hide()
        this.showtxt = false;
        this.disabled = false;
      }

    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  getSessionData() {
    this.spinner.show();
    const payload = {};
    payload['SnNo'] = this.session
    this.umsService.getSession(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.sessionList = res.data;
        this.SessionFilterList = this.sessionList.slice();
        this.subjectSelectionDetailsForm.controls['SubSession'].setValue(res.data[0].SnNo);
      }
      else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.sessionList = [];
      let data = {}
      this.spinner.hide();
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);

    });
  }



  getSubjectSelectionData() {
    this.spinner.show();
    const payload = {};
    payload['StuId'] = this.StudentPersonalId;
    payload['SubSession'] = parseInt(this.session);
    this.umsService.getSubSelectionDetails(payload).subscribe(res => {
      this.StatusData = res.data;
      if (res.status) {
        this.spinner.hide();
        this.submitButton = false;
        this.updateButton = true;
        let data = res.data[0]
        sessionStorage.setItem('SubSecId', res.data[0].SubSecId);
        res.data[0].StuSubjectRg = res.data[0].StuSubjectRg.split(",")
        let snNoo = parseInt(res.data[0].SubSession);
        this.getCourseData(data.SubFacId);
        this.getExamStreamData(res.data[0].SubCoId);
        this.selectedValues = res.data[0].StuSubjectRg;
        // this.getSessionData()
        this.selectedValues = res.data[0].StuSubjectRg;
        const dataArray = res.data[0].StuSubjectRgCopy.split(',');
        dataArray.forEach(item => {
          const splitValues = item.split('-');
          const obj = {
            Code: splitValues[0],
            Id: splitValues[1]
          };
          this.newSelectedValues.push(obj);
        });
        this.subjectSelectionDetailsForm = this.fb.group({
          StuId: new FormControl(this.StudentPersonalId),
          SubSession: new FormControl(parseInt(res.data[0].SubSession)),
          SubFacId: new FormControl(data.SubFacId),
          SubCoId: new FormControl(data.SubCoId),
          SubBrId: new FormControl(data.SubBrId),
          SubEmId: new FormControl(parseInt(data.SubEmId)),
          StuSubjectRg: new FormControl(''),
          SubCgId: new FormControl(data.SubCgId),
        });



      }
      else {
        this.spinner.hide()

      }
    }, (ERROR: HttpErrorResponse) => {
      this.sessionList = [];
      let data = {}
      this.spinner.hide();
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);

    });
  }


  getApplyData() {
    let payload = {}
    this.Course = ''
    this.College = ''
    payload['LoginId'] = sessionStorage.getItem('loginId');
    this.umsService.getApplyData(payload).subscribe((res) => {
      if (res.status) {
        this.Course = res.data[0]['Course'];
        this.subjectSelectionDetailsForm.controls['SubCgId'].setValue(res.data[0].College);
        this.getCourse(this.Course)
      }
      else {
        this.Course = ''
        this.College = ''
      }
    }, (ERROR: HttpErrorResponse) => {
      this.Course = ''
      this.College = ''
    });
  }

  getCourse(id) {
    const payload3 = {};
    payload3['CoCode'] = id;
    this.filteredstucourseClgMapListList = [];
    this.umsService.fetchstucourseClgMap(payload3).subscribe(res => {
      if (res.status) {
        this.spinner.hide()
        this.stucourseClgMapList = res.data;
        this.filteredstucourseClgMapListList = this.stucourseClgMapList.slice();
        // this.subjectSelectionDetailsForm.controls['SubCgId'].setValue(res.data[0].CgCode);
      }
      else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });

    this.umsService.fetchCourseType(payload3).subscribe(res => {
      if (res.status) {
        this.spinner.hide()
        this.courseList = res.data;
        this.filteredCourseList = this.courseList.slice();
        this.subjectSelectionDetailsForm.controls['SubCoId'].setValue(res.data[0].CoCode);
        this.getFacultyData(res.data[0].CoFcCode);
        // if(this.Course != ''){ CoFcCode
        //   this.admissionDetailsForm.controls['StuFacId'].setValue(res.data[0]['CoFcCode']);
        //   this.admissionDetailsForm.controls['StuCoId'].setValue(this.Course);
        // }

      }
      else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });

    let payload = {}
    payload['CoCode'] = id;
    payload['EmId'] = 0;
    this.umsService.fetchCourseBranch(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide()
        this.courseStreamList = res.data;
        this.filteredStreamList = this.courseStreamList.slice();
        this.subjectSelectionDetailsForm.controls['SubBrId'].setValue(res.data[0].StrId);
      }
      else {
        this.spinner.hide()
        this.BranchId = 0;
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    }
    );
  }

  getAdmissionDetails() {
    let payload = {};
    payload['StuId'] = this.StudentPersonalId;
    this.umsService.fetchAddmissionDetails(payload).subscribe((res) => {
      if (res.status) {
        this.addmissionData = res.data[0];
        this.CourseCodeee=res.data[0].StuCoId

      }
    })
  }

  getRgId() {
    const payload = {};
    payload['StuId'] = this.StudentPersonalId
    this.umsService.RgId(payload).subscribe((res) => {
      if (res.status) {
        this.examform(res.data[0]['RgId'])
        this.GetFailStudStatus(res.data[0]['RgId'])
      }
      else {

      }
    })
  }

  examform(RgId) {
    const payload = {};
    payload['RgId'] = RgId;
    this.RgIdd = RgId
    payload['CoCode'] = this.CourseCodeee
    this.umsService.fetchLatestEcid(payload).subscribe((res) => {
      if (res.status) {
        this.ExamSrNo = res.data[0].SubjectSelectionEmSrNo
        this.subjectSelectionDetailsForm.controls['SubEmId'].setValue(parseInt(res.data[0].SubjectSelectionEmId));
        this.getSubselectEditControl(res.data[0]['SubjectSelectionShId'])
        this.ShIddddd =res.data[0]['SubjectSelectionShId']
      } else {
        this.subjectSelectionDetailsForm.controls['SubEmId'].setValue('');
      }
    });
  }

  checksubjectselectselectionlistupdate(Shid) {
    let payload = {};
    payload['EcShId'] = Shid;
    payload['EcInCode'] = 64;
    payload['EcOpId'] = 0;
    this.umsService.getSupExamEditRecord(payload).subscribe((res) => {
      if (res.status) {
        const statusO = res.data.find(item => item.EcStatus === "O")?.EcStatus;
        this.hasStatusU = res.data.some(item => item.EcStatus === 'U');
        this.hasStatusO = res.data.some(item => item.EcStatus === 'O');
        if (this.hasStatusO) {
          // Status 'O' present, so enable button and do not show message
          this.disableButton = false;
          this.msgShow = false;
        } 
        else if (this.hasStatusU && this.StatusData == '') {
          this.disableButton = true;
          
        } else if (this.hasStatusU && this.StatusData != '') {
         this.disableButton = true;
          this.msgShow = false;
        }
      } 
      else {
        // this.disableButton = false;
      }
    });
  }


  getSubselectEditControl(Shid) {
    let payload = {};
    payload['EcShId'] = Shid;
    payload['EcInCode'] = 64;
    payload['EcOpId'] = 0;
    this.umsService.getSupExamEditRecord(payload).subscribe((res) => {
      if (res.status) {
        const statusO = res.data.find(item => item.EcStatus === "O")?.EcStatus;
      
        // if (res.data[0].InDesc == 'Subject Selection' && res.data[0].EcStatus == 'U' && this.StatusData == '') {
        //   this.Message = 'The schedule for subject selection is closed.'
        //   this.disableButton = true;
        //   this.msgShow = true
        // }
        // else if (res.data[0].InDesc == 'Subject Selection' && res.data[0].EcStatus == 'U' && this.StatusData != '') {
        //   this.disableButton = true;
        //   this.msgShow = false
        // }
        // else if (res.data[0].InDesc == 'Subject Selection' && res.data[0].EcStatus == 'O') {
        //   this.disableButton = false;
        //   this.msgShow = false
        // }

        this.hasStatusU = res.data.some(item => item.EcStatus === 'U');
        this.hasStatusO = res.data.some(item => item.EcStatus === 'O');


        if (this.hasStatusO) {
          // Status 'O' present, so enable button and do not show message
          this.disableButton = false;
          this.msgShow = false;
        } 
        else if (this.hasStatusU && this.StatusData == '') {
          this.msgShow = true;
          // Status 'U' present and StatusData is empty, show message and disable button
          this.Message = 'The schedule for subject selection is closed.';
          this.disableButton = true;
          
        } else if (this.hasStatusU && this.StatusData != '') {
          // Status 'U' present but StatusData is not empty, just disable button
          this.disableButton = true;
          this.msgShow = false;
        }
      } else {
        // this.disableButton = false;
      }
    });
  }


  //This is For Only KKH University
  ReAddmission(data) {
    let payload = {}
    payload["AdRgId"] = this.RgIdd,
      payload["AdSrNo"] = this.ExamSrNo,
      payload["AdEmId"] = data.SubEmId,
      payload["AdStrId"] = data.SubBrId,
      payload["AdCgCode"] = data.SubCgId,
      payload["AdSnNo"] = data.SubSession,
      payload["AdSub"] = data.StuSubjectRg,
      payload["AdFNR"] = 'N',
      payload["AdCate"] = 'R',
      payload["AdPrefCent"] = '',
      payload["AdDecl"] = '',
      payload["AdProcFlag"] = ''
    this.umsService.addReadmissionDetails(payload).subscribe(res => {
      if (res.status) {
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        // this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);

      }
      else {

      }

    }, (ERROR: HttpErrorResponse) => {

      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      // this.ngOnInit();
      this.dialogRef.afterClosed().subscribe((result) => {
        // this.NewCoSch(payload.StuCoId, payload.SessionId, payload.StuId, payload.StuCgId);
      });
    });
  }


  updateReAddmission(data) {
    let payload = {}
    payload["AdRgId"] = this.RgIdd,
      payload["AdSrNo"] = this.ExamSrNo,
      payload["AdEmId"] = data.SubEmId,
      payload["AdStrId"] = data.SubBrId,
      payload["AdCgCode"] = data.SubCgId,
      payload["AdSnNo"] = data.SubSession,
      payload["AdSub"] = data.StuSubjectRg,
      payload["AdFNR"] = 'N',
      payload["AdCate"] = 'R',
      payload["AdPrefCent"] = '',
      payload["AdDecl"] = '',
      payload["AdProcFlag"] = ''
    this.umsService.updateReadmissionDetails(payload).subscribe(res => {
      if (res.status) {
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        // this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);

      }
      else {

      }

    }, (ERROR: HttpErrorResponse) => {

      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      // this.ngOnInit();
      this.dialogRef.afterClosed().subscribe((result) => {
        // this.NewCoSch(payload.StuCoId, payload.SessionId, payload.StuId, payload.StuCgId);
      });
    }
    );
  }

  GetFailStudStatus(RgId){
    const payload = {};
    payload['RgId'] = RgId;
    this.umsService.GetFailStudStatus(payload).subscribe(res => {
      if(res.status){
        this.submitButton = false;
        this.updateButton = false; 
        this.msgFail = true;
        this.Message2 = 'You Are Not Eligible For This Exam'
      }
      else{
        this.msgFail = false;
        this.Message2 = ''
        // this.Failed = false;
      }
    }, (ERROR: HttpErrorResponse) => {
      // this.Failed = true;
      this.msgFail = false;
      this.Message2 = ''
      this.spinner.hide();
    })
  }

}